<template>
    <header :style="headerStyle" class="relative aspect-[4.2] w-full h-auto">
        <div class="desktop-header">
            <img
                @click="router.push({ name: 'home' })"
                class="logo"
                :src="logo"
                alt="Logo KAMEO Bikes"
            />
            <div class="navigation">
                <div
                    class="vignette shop"
                    :class="{ inactive: shopIsInactive }"
                    @click="router.push({ name: 'home-shop' })"
                >
                    Shop
                </div>
                <div
                    class="vignette pro"
                    :class="{ inactive: proIsInactive }"
                    @click="router.push({ name: 'home-pro' })"
                >
                    Pro
                </div>
                <div
                    class="vignette repair"
                    :class="{ inactive: repairIsInactive }"
                    @click="router.push({ name: 'home-repair' })"
                >
                    Repair
                </div>
            </div>
            <div class="action">
                <div class="vignette small connection" @click="login">
                    <i class="fas fa-user"></i>
                </div>
                <div
                    class="vignette small contact"
                    @click="router.push({ name: 'contact' })"
                >
                    <i class="fas fa-envelope"></i>
                </div>
            </div>
        </div>
        <div class="mobile-header">
            <img
                @click="router.push({ name: 'home' })"
                class="logo"
                :src="logo"
                alt="Logo KAMEO Bikes"
            />
            <div class="burger" @click="menuToggle" z-index="1000000">
                <i class="fas fa-bars"></i>
            </div>
            <div class="menu" :class="{ hide: isMenuHidden }">
                <div class="top">
                    <div class="connection">
                        <i @click="login" class="fas fa-user text-white"></i>
                    </div>
                    <div class="close" @click="menuToggle">
                        <i class="fas fa-times text-white"></i>
                    </div>
                </div>
                <div class="body">
                    <p
                        @click="router.push({ name: 'home' })"
                        class="text-white"
                    >
                        <i class="fas fa-home"></i>Accueil
                    </p>
                    <p
                        @click="router.push({ name: 'home-shop' })"
                        class="bg-red text-white"
                    >
                        <i class="fas fa-shopping-cart"></i>Shop
                    </p>
                    <p
                        @click="router.push({ name: 'home-pro' })"
                        class="bg-green text-white"
                    >
                        <i class="fas fa-user"></i>Pro
                    </p>
                    <p
                        @click="router.push({ name: 'home-repair' })"
                        class="bg-blue text-white"
                    >
                        <i class="fas fa-tools"></i>Repair
                    </p>
                </div>
            </div>
        </div>
        <RouterLink
            v-if="soldes"
            :to="{
                name: 'bikes-catalog-category',
                query: {
                    utilisation: 'all',
                    promotion: true,
                },
            }"
            class="text-white font-bold md:text-4xl p-2 absolute bottom-2"
            style="
                background-color: #d60b52;
                left: 50%;
                transform: translateX(-50%);
                white-space: nowrap;
            "
            >Découvrez nos soldes</RouterLink
        >
    </header>
</template>
<script setup>
import { computed, onMounted, ref, watch } from 'vue';
import { useRouter } from 'vue-router';

import { useAuthStore } from '@/js/stores/authStore';

const authStore = useAuthStore();
const router = useRouter();
const shopIsInactive = ref(false);
const proIsInactive = ref(false);
const repairIsInactive = ref(false);
const isMenuHidden = ref(true);

const props = defineProps({
    logo: {
        type: String,
        default: '/storage/assets/logos/rectangle_noir.png',
    },
    banner: {
        type: String,
        default: '/storage/assets/images/banners/home.webp',
    },
    connectionIsVisible: {
        type: Boolean,
        default: false,
    },
    contactIsVisible: {
        type: Boolean,
        default: false,
    },
    soldes: {
        type: Boolean,
        default: false,
    },
});

const headerStyle = computed(() => {
    return {
        backgroundImage: props.soldes
            ? `url('/storage/assets/images/banners/soldes.jpg')`
            : `url(${props.banner})`,
    };
});
watch(
    () => props.banner,
    newValue => {
        if (newValue) {
            document.querySelector('header').style.backgroundImage = newValue;
        }
    },
);

const login = () => {
    if (authStore.$state.isAuth) {
        router.push({ name: 'index-dashboard' });
    } else {
        router.push({ name: 'login' });
    }
};

onMounted(() => {
    if (router.currentRoute.value.fullPath.includes('/shop')) {
        proIsInactive.value = true;
        repairIsInactive.value = true;
    } else if (router.currentRoute.value.fullPath.includes('/pro')) {
        shopIsInactive.value = true;
        repairIsInactive.value = true;
    } else if (router.currentRoute.value.fullPath.includes('/repair')) {
        shopIsInactive.value = true;
        proIsInactive.value = true;
    }
});

const menuToggle = () => {
    console.log('click');
    isMenuHidden.value = !isMenuHidden.value;
    document.querySelector('body').classList.toggle('no-scroll');
};
</script>
<style lang="scss" scoped>
@use '@/scss/variables' as vars;

// Desktop header
@media screen and (min-width: vars.$mediumBreakpoint) {
    .mobile-header {
        display: none;
    }

    header {
        background-size: cover;
        background-position: center;
        background-repeat: no-repeat;
        height: 350px;
        box-shadow: vars.$defaultShadow;
    }

    header > div {
        display: flex;
        justify-content: space-between;
        height: 75px;
        padding: 0 1rem;
        width: 100%;
    }

    .logo {
        height: 100%;
        cursor: pointer;
    }

    .navigation {
        display: flex;
        justify-content: center;
        margin-left: -75px;
    }

    .vignette {
        display: flex;
        justify-content: center;
        align-items: center;
        width: 100px;
        height: 70px;
        margin: 0 5px;
        background-color: vars.$blackColor;
        color: vars.$whiteColor;
        font-weight: bold;
        text-transform: uppercase;
        font-size: vars.$primaryFontSize;
        border-bottom-left-radius: vars.$borderRadius;
        border-bottom-right-radius: vars.$borderRadius;
        transition: all 0.5s ease-in-out;
        cursor: pointer;

        &:hover {
            background-color: vars.$greenColor;
            color: vars.$whiteColor;
            box-shadow: vars.$defaultShadow;
        }

        &.shop {
            background-color: vars.$redColor;
            color: vars.$whiteColor;
        }

        &.pro {
            background-color: vars.$greenColor;
            color: vars.$whiteColor;
        }

        &.repair {
            background-color: vars.$blueColor;
            color: vars.$whiteColor;
        }

        &.inactive {
            background-color: vars.$whiteColor;
            color: vars.$blackColor;
        }

        &.small {
            width: 50px;
            height: 50px;
            font-size: vars.$secondaryFontSize;
        }
    }

    .action {
        display: flex;
        justify-content: center;
        visibility: hidden;
        .vignette {
            margin: 0 5px;
            background-color: vars.$whiteColor;
            color: vars.$blackColor;
            box-shadow: vars.$defaultShadow;
            cursor: pointer;

            &:hover {
                background-color: vars.$blackColor;
                color: vars.$whiteColor;
            }
        }
    }

    .connection > i,
    .contact > i {
        font-size: vars.$defaultFontSize;
    }
}

@media screen and (max-width: vars.$mediumBreakpoint) {
    .desktop-header {
        display: none;
    }

    .mobile-header {
        padding-left: 0;
    }

    header {
        background-size: cover;
        background-position: center;
        background-repeat: no-repeat;
        height: 350px;
        box-shadow: vars.$defaultShadow;
    }

    header > div {
        display: flex;
        justify-content: space-between;
        height: 75px;
        padding: 0 1rem;
        width: 100%;
    }

    .logo {
        height: 60%;
        cursor: pointer;
    }

    .burger {
        display: flex;
        align-items: center;
        height: 100%;
        color: vars.$whiteColor;
        font-size: vars.$primaryFontSize;
        transition: all 0.5s ease-in-out;
        cursor: pointer;
    }

    .menu {
        position: fixed;
        top: 0;
        left: 0;
        z-index: 100;
        width: 100%;
        height: 100%;
        transform: translateX(0);
        transition: all 0.5s ease-in-out;
        box-shadow: vars.$defaultShadow;
        background: url('/storage/assets/images/freestyleBike.jpg') center
            center no-repeat;
        background-size: cover;

        &::before {
            content: '';
            position: absolute;
            top: 0;
            left: 0;
            height: 100%;
            width: 100%;
            background-color: rgba(0, 0, 0, 0.8);
            z-index: -1;
        }

        &.hide {
            transform: translateX(-100%);
        }

        .header {
            display: flex;
            justify-content: space-between;
            align-items: center;
            height: 75px;
            padding: 0 1rem;
            width: 100%;
        }

        .logo {
            height: 100%;
            cursor: pointer;
        }

        .body {
            display: flex;
            flex-direction: column;
            justify-content: center;
            align-items: center;
            height: calc(100% - 75px);
            width: 100%;

            p {
                display: flex;
                justify-content: center;
                align-items: center;
                width: 100%;
                height: 50px;
                font-weight: bold;
                text-transform: uppercase;
                font-size: vars.$primaryFontSize;
                transition: all 0.5s ease-in-out;
                cursor: pointer;

                &:hover {
                    background-color: vars.$greenColor;
                    color: vars.$whiteColor;
                    box-shadow: vars.$defaultShadow;
                }

                i {
                    margin-right: 1rem;
                }
            }
        }

        .top {
            display: flex;
            justify-content: space-between;
            padding: 1rem;

            &.close {
                display: flex;
                align-items: center;
                color: vars.$blackColor;
                transition: all 0.5s ease-in-out;
            }
        }
    }
}
</style>
